export const ReceiptSupplierPage = () => {
  return <>ReceiptSupplierPage</>;
};
